module.exports = __webpack_public_path__ + "d68d99b188851a0587cd5349929e8526.svg";